import { LoadingIndicator } from '../../../common/components/loading-indicator';
import { ErrorBoundary } from '../../../monitoring/error-boundary';
import { observer } from 'mobx-react-lite';
import { useCurrentUser } from '../../../current-user/current-user';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { ProQaAdditionalInfos } from '../../../additional-infos/proqa-additional-infos/proqa-additional-infos';

export const ProQaTab = observer(function ProQaTab() {
    const { linkedEntityId: agencyEventId, isFocused } = useWorkspacePanel();
    const eventMetadata = useEventMetadataStore().state.metadata;
    const agencyEventNumber = eventMetadata?.agencyEventNumber;
    const { userId } = useCurrentUser();

    if (!agencyEventNumber || !agencyEventId) {
        return <LoadingIndicator />;
    }

    return (
        <EventPanelTab title="ProQA">
            <TabBody constrainToParentHeight={true}>
                <ErrorBoundary name="PRO_QA_ADDITIONAL_INFOS">
                    <ProQaAdditionalInfos
                        agencyEventId={agencyEventId}
                        agencyEventNumber={agencyEventNumber}
                        markVisibleInfosAsRead={isFocused}
                        currentUserId={userId}
                        hideTitle={true}
                    />
                </ErrorBoundary>
            </TabBody>
        </EventPanelTab>
    );
});
